import React from "react";
import { LocalizedLink as Link } from "./LocalizedLink";
import { ArrowRight } from "lucide-react";

export default function TreatmentCard({
  image,
  title,
  age,
  aditional,
  description,
  price,
  detailHref,
  detailLabel = "Ver detalles",
}) {
  return (
    <article className="section-surface overflow-hidden flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-elevated">
      <div className="h-56 w-full overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
        />
      </div>

      <div className="flex flex-col flex-grow p-5">
        {price && (
          <span className="inline-block bg-green-100 text-turquoise font-semibold text-xs px-3 py-1 rounded-full mb-2">
            {price}
          </span>
        )}

        {age && (
          <span className="inline-block bg-turquoise/20 text-turquoise font-semibold text-xs px-3 py-1 rounded-full mb-2">
            {age}
          </span>
        )}

        <h3 className="text-2xl font-bold text-gray-800 mb-3 border-b-2 border-turquoise pb-1">
          {title}
        </h3>
        <p className="body-copy flex-grow leading-relaxed">{description}</p>
      </div>

      <div className="text-sm p-5">
        {aditional.map((benefit, index) => (
          <div key={index} className="flex items-center gap-2">
            <div className="w-2 h-2 bg-turquoise rounded-full flex-shrink-0" />
          <span className="text-foreground">{benefit}</span>
        </div>
      ))}
      </div>

      {detailHref && (
        <div className="px-5 pb-5 mt-auto">
          <Link
            to={detailHref}
            className="inline-flex items-center justify-center gap-2 rounded-lg border border-turquoise px-4 py-2 text-sm font-semibold text-turquoise transition-colors hover:bg-turquoise/10"
            aria-label={`${detailLabel}: ${title}`}
          >
            {detailLabel}
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      )}
    </article>
  );
}
